import {PortableText} from '../portableText/PortableText'
import {SanityImage} from '../sanityImage/SanityImage'

export interface ImageStripProps {
	imageStrip: any
	className: string
}

export const ImageStrip = ({imageStrip, className}: ImageStripProps) => {
	console.log(imageStrip)
	return (
		<div className={className}>
			<div className='w-screen bg-[#8486EC33] h-340 flex flex-col justify-center items-center'>
				<div className='flex mx-auto span-w-11 justify-around flex-wrap items-center'>
					{imageStrip?.map((item, idx) => {
						if (item._type === 'imageWithCaption') {
							return (
								<div
									key={idx}
									className='flex flex-col bg-[#FCF9ED] border p-16 rounded-lg shadow-lg'>
									<SanityImage
										className='w-320 mb-14'
										image={item.image}
										desktopWidth={320} />
									<div className='text-18 mx-auto'>{item.caption}</div>
								</div>
							)
						} else {
							return (
								<PortableText className='span-w-4 text-16' key={idx} blocks={item.text} />
							)
						}
					})}
				</div>
			</div>
		</div>
	)
}
